module.exports = __webpack_public_path__ + "img/length.a0b05977.png";